import { connect } from "react-redux";
import { Dispatch } from "redux";
import { loginPageActions } from "../../../pages/login/login-page.store";
import { RootState } from "../../../store/index.store";
import { dialogPropsSelector } from "../../../store/ui.store";
import { LoginDialog as LoginDialogComponent } from "./LoginDialog";

const mapStateToProps = (state: RootState) => ({
  dialogProps: dialogPropsSelector(state)
});

const mapStateToDispatch = (dispatch: Dispatch) => ({
  submit: (values: any) =>
    dispatch(
      loginPageActions.USER_CLICKED_LOGIN_BUTTON({
        username: values.username,
        password: values.password
      })
    )
});

export const LoginDialog = connect(
  mapStateToProps,
  mapStateToDispatch
)(LoginDialogComponent);
